import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, withModifiers as _withModifiers, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "fcs" }
const _hoisted_2 = {
  key: 1,
  class: "fcs-loading",
  role: "status"
}
const _hoisted_3 = {
  key: 2,
  class: "fcs-box"
}
const _hoisted_4 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = {
  key: 0,
  class: "fcs-error",
  role: "alert"
}
const _hoisted_8 = { class: "fcs-actions" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 3,
  class: "fcs-error",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.phase == 'idle')
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "ai-btn ai-btn-ghost fcs-start",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.draft()))
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("svg", {
            "aria-hidden": "true",
            xmlns: "http://www.w3.org/2000/svg",
            width: "14",
            height: "14",
            viewBox: "0 0 24 24",
            fill: "currentColor",
            "fill-rule": "evenodd"
          }, [
            _createElementVNode("path", { d: "M12 23c-4.4 0-8-3.1-8-7.5 0-3.3 2-5.6 3.6-7.4.4-.4 1.1-.1 1.1.5 0 1.3.6 2.6 1.6 3.2C10.1 7.7 11.6 4 15 1.2c.4-.3 1 0 1 .5-.1 2.6.9 4.5 2.2 6.4C19.3 9.8 20 11.6 20 15.5 20 19.9 16.4 23 12 23zm0-2c1.9 0 3.3-1.3 3.3-3.1 0-1.6-.9-2.7-2.1-3.9-.3-.3-.8-.1-.8.3-.1 1-.6 1.8-1.3 2.2-.1-1.1-.5-2-1.1-2.6-.3-.3-.8-.1-.8.3-.3 1.3-1.5 2.2-1.5 3.7C7.7 19.7 9.8 21 12 21z" })
          ], -1),
          _createTextVNode(" Break into steps ", -1)
        ]))]))
      : (_ctx.phase == 'loading')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "The Forge is writing the steps…"))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "fcs-head" }, [
              _createTextVNode("Steps from the Forge "),
              _createElementVNode("span", null, "Edit, untick or add, then add them as a checklist.")
            ], -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (st, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: _normalizeClass(["fcs-step", { 'fcs-off': !st.keep }])
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": ($event: any) => ((st.keep) = $event),
                  "aria-label": 'Keep step ' + (i + 1)
                }, null, 8, _hoisted_4), [
                  [_vModelCheckbox, st.keep]
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": ($event: any) => ((st.name) = $event),
                  rows: "1",
                  maxlength: "500",
                  "aria-label": "Step"
                }, null, 8, _hoisted_5), [
                  [_vModelText, st.name]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  "onUpdate:modelValue": ($event: any) => ((st.date) = $event),
                  "aria-label": "Date"
                }, null, 8, _hoisted_6), [
                  [_vModelText, st.date]
                ])
              ], 2))
            }), 128)),
            _createElementVNode("a", {
              class: "fcs-add",
              href: "#",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.steps.push({ name: '', date: '', keep: true })), ["prevent"]))
            }, "+ Add a step"),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                type: "button",
                class: "fcs-link",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reset()))
              }, "Cancel"),
              _createElementVNode("button", {
                type: "button",
                class: "ai-btn",
                disabled: !_ctx.kept.length,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.add()))
              }, "Add " + _toDisplayString(_ctx.kept.length) + " step" + _toDisplayString(_ctx.kept.length == 1 ? '' : 's') + " as a checklist", 9, _hoisted_9)
            ])
          ])),
    (_ctx.phase == 'idle' && _ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ]))
}